var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',[_c('h3',[_vm._v("Manage LC Domains")]),_c('div',{staticClass:"col"},[_c('TransferDomain')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }